import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";

window.$ = window.jQuery = require("jquery");

export default {
    name: "RolPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CategoriaDocentePage",
            ss: ss,
            ajax: {
                "url": ss.indexCategoriaDocente(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Categoria', name: 'Categoria', title: 'Categoria' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                { data: 'Abreviatura', name: 'Abreviatura', title: 'Abreviatura' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                }, 
            ],

            categoria:{},
            categorias: [],
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newCategoria() {
            this.categoria = {};
            this.$refs['frm-categoria'].show();
        },
     
        editCategoria(id){
            this.categoria = {};
            this.ss.showCategoriaDocente(id)
            .then((result) => {
              let response = result.data;
              this.categoria = response.data[0];
              this.$refs['frm-categoria'].show();
            })
            .catch(error => {
              console.log(error);
              this.isLoading = false;
            });
        },

        showCategoria(id) {
            this.categoria = {};
            this.isLoading = true;
            this.ss.showCategoriaDocente(id)
              .then((result) => {
                let response = result.data;
                this.categoria = response.data[0];
                this.$refs['view-categoria'].show();
                this.isLoading = false;
              })
              .catch(error => {
                console.log(error);
                this.isLoading = false;
              });
        },

        cancelShowCategoria(){
            this.categoria = {};
            this.$refs['view-categoria'].hide();
        },

      
        cancelStoreCategoria() {
            this.categoria = {};
            this.$refs['frm-categoria'].hide();
        },
        saveCategoria() {
            this.ss.storeCategoriaDocente(this.categoria).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    this.$refs['frm-categoria'].hide();
                    this.$refs['datatable-Categoria'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        
        deleteCategoria(id) {

            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible.",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.ss.deleteCategoriaDocente({ id: id })  
                        .then((result) => {
                            let response = result.data;
                            console.log(response);
                            this.$bvToast.toast(
                                response.msg, 
                                {
                                    title: 'Correcto',
                                    variant: 'success',
                                    autoHideDelay: 5000
                                }
                            )
                            this.$refs['datatable-Categoria'].reload();
                        })
                        .catch(error => {
                            console.log(error);
                        })
                } else {
                    // No hacer nada si el usuario cancela la eliminación
                }
            });
        },
        
        
        draw() {
            window.$('.btn-datatable-Categoria').on('click', (evt) => {
                const buttonId = window.$(evt.target).closest('button').attr('id'); 
                
                if (buttonId.includes('details_')) {
                    const id = buttonId.replace('details_', ''); 
                    this.showCategoria(id);
                } 
                else if (buttonId.includes('edit_')) {
                    const id = buttonId.replace('edit_', ''); 
                    this.editCategoria(id);
                } 
                else if (buttonId.includes('delete_')) {
                    const id = buttonId.replace('delete_', ''); 
                    this.deleteCategoria(id);
                }
            });
        }
    },
    components: {
        dataTable,
     
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{
            this.auth = persona;
        }
    }
};
